import React, { useContext, useEffect, useState } from 'react'
import './index.scss'
import { useLocation } from 'react-router'
import { ICONS } from '@Const/common'
import UserMenu from '@Components/Navigations/UserMenu'
import RightsholderTray from '@Components/Navigations/RightsHoldersTray'
import { StoresContext } from '@App/contexts'
import { observer } from 'mobx-react'
import clsx from 'clsx'
import MemberSongwriterSwitcher from '@Components/Navigations/MemberSongwriterSwitcher'
import NavBarWrapper from '@Components/Navigations/NavBar/NavBarWrapper'
import MobileSubNavigation from '@Components/Navigations/NavBar/MobileSubNavigation'
import PublicSearchNavLink from '@Components/Navigations/PublicSearchNavLink'
import HelpMenu from '@Components/Navigations/HelpMenu'
import NotificationInbox from '@Components/Navigations/NavBar/NotificationInbox'
import Conditional from '@Components/Utility/Conditional'

const LoggedInNavBar = () => {
    const { userStore, rightsholderSearchStore, uiStore, popupStore } = useContext(StoresContext)
    const [isOpen, setIsOpen] = useState(false)
    const location = useLocation()

    const burgerClick = () => {
        setIsOpen(!isOpen)
    }

    const onCloseMenu = () => {
        setIsOpen(false)
    }

    const closeTray = () => {
        popupStore.setRightsholderTrayState(false)
    }

    useEffect(() => {
        onCloseMenu()
        closeTray()
    }, [location])

    const isInternal = userStore.isInternal
    const rightsHolderCount = rightsholderSearchStore.rightsholderCount
    const isMobile = uiStore.isMobile
    const trayIsOpen = popupStore.rightsholderTrayState

    return (
        <>
            <NavBarWrapper
                wrapperClass={clsx(isInternal && 'internal-user')}
                accountingBlock={<MemberSongwriterSwitcher />}
                rightBlock={
                    <>
                        <span className="right-links only-desktop">
                            <PublicSearchNavLink />
                            <HelpMenu />
                            <Conditional conditional={!isInternal}>
                                <NotificationInbox />
                            </Conditional>
                        </span>
                        <UserMenu />
                    </>
                }
                burgerBlock={
                    <>
                        <div className="burger-button" onClick={burgerClick}>
                            {isOpen ? (
                                <img className="close-icon" src={ICONS.close} alt="close" />
                            ) : (
                                <img src={ICONS.menu} alt="menu" />
                            )}
                        </div>
                    </>
                }
            >
                {isMobile && <MobileSubNavigation isOpen={isOpen} />}
            </NavBarWrapper>
            {!isMobile && rightsHolderCount > 1 && trayIsOpen && (
                <>
                    <RightsholderTray />
                    <div className="stub" />
                </>
            )}
        </>
    )
}

export default observer(LoggedInNavBar)
